import * as types from './types';

export default {
  [types.CACHE_JOBS_RECOMMENDED_PERSON](state, { key, data }) {
    state.cachedJobsRecommendedPerson[key] = data;
  },
  [types.SET_RECOMMENDATIONS_BY_JOB](state, jobsRecommendedPerson) {
    state.recommendationsByJob = jobsRecommendedPerson;
  },
  [types.CACHE_RECOMMENDATIONS_BY_JOB](state, { key, data }) {
    state.cachedRecommendationsByJob[key] = data;
  },
  [types.SET_JOBS_RECOMMENDED_PERSON](state, persons) {
    state.jobsRecommendedPerson = persons;
  },
  [types.CACHE_JOBS_I_WAS_INDICATED_PERSON](state, { key, data }) {
    state.cachedJobsRecommendedPerson[key] = data;
  },
  [types.SET_JOBS_I_WAS_INDICATED_PERSON](state, jobsRecommendedPerson) {
    state.recommendationsByJob = jobsRecommendedPerson;
  },
  [types.CACHE_INDICATIONS_I_RECEIVED_BY_JOB](state, { key, data }) {
    state.cachedRecommendationsByJob[key] = data;
  },
  [types.SET_INDICATIONS_I_RECEIVED_BY_JOB](state, persons) {
    state.jobsRecommendedPerson = persons;
  },
  [types.CACHE_INDICATIONS_BY_JOB_ID](state, { key, data }) {
    state.cachedIndicationsByJobId[key] = data;
  },
  [types.SET_INDICATIONS_BY_JOB_ID](state, indications) {
    state.indicationsByJobId = indications;
  },
};
